import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@fontsource/dm-sans';
import "@fontsource/dm-sans/500.css";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
//<React.StrictMode>
_jsx(App, {})
//</React.StrictMode>
);
